module.exports = __webpack_public_path__ + "538b08487a5fee30f4b81e56f0d5e397.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/8-dogs.svg
// module id = 74
// module chunks = 0